var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { supportedChains } from '@lifi/sdk';
import WalletConnectProvider from '@walletconnect/ethereum-provider';
import { initializeConnector } from '@web3-react/core';
import { Connector } from '@web3-react/types';
export class WalletConnect extends Connector {
    constructor(actions, options) {
        super(actions);
        this.isCurrentlyUsed = false;
        this.connectEagerly = () => { };
        this.options = options;
    }
    startListening() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            // Subscribe to accounts change
            (_a = this.provider) === null || _a === void 0 ? void 0 : _a.on('accountsChanged', (accounts) => {
                this.actions.update({ accounts });
            });
            // Subscribe to chainId change
            (_b = this.provider) === null || _b === void 0 ? void 0 : _b.on('chainChanged', (chainId) => {
                this.actions.update({ chainId });
            });
            // Subscribe to session disconnection
            (_c = this.provider) === null || _c === void 0 ? void 0 : _c.on('disconnect', (code, reason) => {
                this.actions.update({ accounts: [], chainId: undefined });
                this.actions.resetState();
                this.isCurrentlyUsed = false;
            });
        });
    }
    activate() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.actions.startActivation();
            this.isCurrentlyUsed = true;
            // Reset provider for every connection attempt
            const walletConnectProvider = new WalletConnectProvider({
                rpc: this.options.rpc,
            });
            this.provider =
                walletConnectProvider;
            this.walletConnectProvider = walletConnectProvider;
            yield ((_a = this.provider) === null || _a === void 0 ? void 0 : _a.enable()); // open modal
            this.startListening();
            this.actions.update({ accounts: this.provider.accounts });
            this.actions.update({ chainId: this.provider.chainId });
        });
    }
    deactivate() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.provider) {
                yield ((_a = this.provider) === null || _a === void 0 ? void 0 : _a.disconnect());
                this.isCurrentlyUsed = false;
                this.actions.resetState();
            }
        });
    }
}
export const [walletConnect, hooks] = initializeConnector((actions) => new WalletConnect(actions, {
    rpc: Object.fromEntries(supportedChains.map((chain) => {
        return [chain.id, chain.metamask.rpcUrls[0] || ''];
    })),
}));
export const createWalletConnectConnector = () => {
    const [connector, hooks] = initializeConnector((actions) => new WalletConnect(actions, {
        rpc: Object.fromEntries(supportedChains.map((chain) => {
            return [chain.id, chain.metamask.rpcUrls[0] || ''];
        })),
    }));
    return { connector, hooks };
};
